import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const varStyles = makeStyles((theme: Theme) => 
    createStyles({
        hindFont:{
            fontFamily:'Hind Siliguri',
        },
        cormorandFont:{
            fontFamily:'Cormorant Garamond',
        },
        primaryColor: {
            color: '#D32F2F'
        },
        secondaryColor: {
            color: '#212121'
        }
    })
);

export default varStyles;